<template>
  <div class="the-logotype">
    <router-link class="the-logotype__image" to="/" title="數據看選舉">
      <SvgSymbol use="#logotype"/>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'TheLogotype'
}
</script>

<style lang="scss">
.the-logotype {
  position: relative;
  height: 131px;
  text-align: center;
  @include use-vertical-align();
  @include rwd($RWD_TABLET_SMALL) {
    height: 163px;
  }
  @include rwd($RWD_TABLET) {
    height: 175px;
  }
  @include rwd($RWD_DESKTOP_1440) {
    height: 235px;
  }

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80px;
    height: 0;
    margin-top: 60px;
    margin-left: -40px;
    border-top: 1px solid #1a1a1a;
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 80px;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 85px;
    }
    @include rwd($RWD_DESKTOP_1440) {
      margin-top: 110px;
    }
  }

  &__image {
    display: inline-block;
    width: 182px;
    height: 86px;
    vertical-align: middle;
    @include rwd($RWD_TABLET_SMALL) {
      width: 230px;
      height: 110px;
    }
    @include rwd($RWD_TABLET) {
      width: 250px;
      height: 120px;
    }
    @include rwd($RWD_DESKTOP_1440) {
      width: 330px;
      height: 158px;
    }
  }
}
</style>
